import { InvoicePaymentCollection, InvoicePaymentModel, ValidateInvoicePayment } from "@auer-steel/Services/InvoicePaymentService";
import { getWalletsList } from "@auer-steel/Services/WalletService";
import { AuerActions, AuerState } from "@auer-steel/Store/AuerState";
import { convertToApiParameter, getInvoicePaymentDiscountAmount } from "@auer-steel/Utilities/PayInvoiceUtilities";
import { ApiHandler, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { API_URL_CURRENT_FRAGMENT } from "@insite/client-framework/Services/ApiService";
import { getBillTo } from "@insite/client-framework/Services/CustomersService";
import { getInvoice } from "@insite/client-framework/Services/InvoiceService";
import { getBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import { getInvoiceState } from "@insite/client-framework/Store/Data/Invoices/InvoicesSelectors";
import { DispatchProp } from "react-redux";

type HandlerType = ApiHandler<{ invoiceNumbers: string[] }, InvoicePaymentCollection, DispatchProp<AuerActions>>;

export const DisplayInvoicePayments: HandlerType = async props => {
    const state = props.getState() as AuerState;
    const foundInvoices = [];
    for (const invoiceNumber of props.parameter.invoiceNumbers) {
        const invoiceState = getInvoiceState(state, invoiceNumber);
        if (!invoiceState.value) {
            const invoice = await getInvoice({ invoiceNumber });
            if (invoice) {
                foundInvoices.push(invoice);
            }
        } else {
            foundInvoices.push(invoiceState.value);
        }
    }

    const newInvoices:InvoicePaymentModel[] = [];

    for (const invoice of foundInvoices.sort((a, b) => b.currentBalance - a.currentBalance)) {
        const newInvoicePayment = {
            invoice,
            payInFull: true,
            paymentAmount: invoice.currentBalance,
            enteredPaymentAmount: String(invoice.currentBalance),
            discountAmount: 0,
        };
        newInvoicePayment.discountAmount = getInvoicePaymentDiscountAmount(newInvoicePayment);
        newInvoices.push(newInvoicePayment);
    }
    let billTo = getBillToState(state, state.context.session.billToId).value;
    if (!billTo) {
        billTo = await getBillTo({ billToId: API_URL_CURRENT_FRAGMENT });
    }

    
    props.dispatch({ type: "Pages/PayInvoice/UpdateAchWalletsAreLoading", parameter: true });
    const wallets = await getWalletsList();

    let selectedWallet = null;
    if (wallets.successful && wallets.result !== undefined) {
        props.dispatch({ type: "Pages/PayInvoice/UpdateAchWallets", parameter: wallets.result });
        selectedWallet = wallets.result[0];
    }
    
    props.dispatch({ type: "Pages/PayInvoice/UpdateAchWalletsAreLoading", parameter: false });
    const result:InvoicePaymentCollection = {
        ...state.payInvoice.invoicePaymentCollection,
        billingAddress: billTo,
        invoicePayments: newInvoices,
        achAccountId: selectedWallet?.PaymentProfileId ?? undefined,
        paymentInformation: {
            routingNumber: selectedWallet?.CardType ?? null,
            bankAccountType: selectedWallet?.Address1 ?? null,
            bankName: selectedWallet?.Address2 ?? null,
            accountNumber: selectedWallet?.PaymentProfileId ?? undefined,
        },
    };

    props.dispatch({ type: "Pages/PayInvoice/UpdateInvoicePayments", parameter: result });
    const validationParameter = convertToApiParameter(result);
    const validationResult = await ValidateInvoicePayment(validationParameter);
    props.dispatch({ type: "Pages/PayInvoice/UpdateValidationResult", parameter: validationResult });
};

export const chain = [DisplayInvoicePayments];

const displayInvoicePayments = createHandlerChainRunner(chain, "DisplayInvoicePayments");
export default displayInvoicePayments;
